import {callsApi} from 'sources/api';

export default {
  deleteCall(callId) {
    return callsApi.delete(`/calls/${callId}`);
  },
  fetchCallTeamName(fileUploadId) {
    return callsApi.getJson(`/calls/${fileUploadId}/team_name`);
  },
};
